import { Component } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { FormApprovalSuccessModalComponent } from '../form-approval-success-modal/form-approval-success-modal.component';

@Component({
  selector: 'app-notes-added-sucesful-modal',
  templateUrl: './notes-added-sucesful-modal.component.html',
  styleUrls: ['./notes-added-sucesful-modal.component.scss']
})
export class NotesAddedSucesfulModalComponent {

public data: any;  

  constructor(protected dialogRef: NbDialogRef<FormApprovalSuccessModalComponent>) {
    this.data = this.dialogRef;  
  }

  approve() {
    this.dialogRef.close(true); // Pass true to indicate approval
  }




}
